<form class="row mx-0 px-0 h-100 w-100 d-flex justify-content-center align-items-start" [formGroup]="directoryForm"
      (ngSubmit)="isValid()">
  <div class="col-12 mb-5 text-center">
    <h4>{{directoryForm['id'] ? 'Edición ' : 'Creación '}}de directorio
    </h4>
  </div>
  <div class="col-12 mb-2 px-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Cargo</mat-label>
      <input formControlName="charge" matInput placeholder="Ingresar cargo..." type="text">
    </mat-form-field>
  </div>
  <div class="col-12 col-xl-6 mb-2 pl-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Nombre</mat-label>
      <input formControlName="name" matInput placeholder="Ingresar nombre..." type="text">
    </mat-form-field>
  </div>
  <div class="col-12 col-xl-6 mb-2 pr-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Orden</mat-label>
      <input formControlName="orderId" matInput placeholder="Ingresar orden..." type="number">
    </mat-form-field>
  </div>
  <div class="col-12 mb-2 px-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Descripción</mat-label>
      <input formControlName="description" matInput placeholder="Ingresar descripción..." type="text">
    </mat-form-field>
  </div>
  <div class="col-12 mb-2 px-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Información</mat-label>
      <textarea #content formControlName="information" [maxLength]="maxLength" matInput placeholder="Ingresar información..." type="text"></textarea>
      <mat-hint align="end">{{content.value?.length || 0}}/{{maxLength}}</mat-hint>
    </mat-form-field>
  </div>
  <button type="submit" class="vs-btn-blue" [disabled]="directoryForm.invalid">
    {{directoryData && directoryData['id'] ? 'Edición ' : 'Creación '}}
    de directorios
  </button>
</form>
